import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, Button } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import dayjs from 'dayjs';
import { series_report } from '../../../actions/WebSeries/series';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor:"#000000"  ,
        color: "#ffffff !important",
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
 
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));
 
export default function SeriesDownload() {
    const dispatch = useDispatch();
    const report = useSelector((state) => state?.webseries?.series_report);
    
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
 
    useEffect(() => {
        dispatch(series_report());
    }, []);

    const handleFilter = () => {
        const params = {};
        
        if (startDate) {
            params.start_date = dayjs(startDate).format('YYYY-MM-DD');
        }
        if (endDate) {
            params.end_date = dayjs(endDate).format('YYYY-MM-DD');
        }
        
        dispatch(series_report(params));
    };

    const handleReset = () => {
        setStartDate(null);
        setEndDate(null);
        dispatch(series_report());
    };
 
    const handleSave = () => {
        const doc = new jsPDF();
 
        const tableColumn = [
            'Name',
            'Video Type',
            'Series View',
            'Total Earning',
            'Tax Amount',
            'Admin Profit',
            'Total Rental Count',
            'Total Season',
            'Total Episode',
            'TVOD Amount',
        ];
 
        const tableRows = report?.message?.map(row => ([
            row.name,
            row.video_type,
            row.series_view,
            row.total_earning,
            row.tax_amount || '-',
            row.admin_profit || '-',
            row.total_rental_count || '-',
            row.total_season,
            row.total_episode,
            row.tvod_amount || '-',
        ])) || [];
 
        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            styles: { fontSize: 8 },
            margin: { top: 20 },
        });
 
        doc.save('series_report.pdf');
    };
   
    return (
        <Box sx={{ m: 3 }}>
            <Box sx={{ my: 3, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="Start Date"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        slotProps={{ textField: { size: 'small' } }}
                    />
                    <DatePicker
                        label="End Date"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        minDate={startDate}
                        slotProps={{ textField: { size: 'small' } }}
                    />
                </LocalizationProvider>
                <Button variant="contained" onClick={handleFilter}>
                    Filter
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleReset}>
                    Reset
                </Button>
                <Button variant="outlined" onClick={handleSave}>
                    Save
                </Button>
            </Box>
            
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="Series Report Table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Name</StyledTableCell>
                            <StyledTableCell align="right">Video Type</StyledTableCell>
                            <StyledTableCell align="right">Series View</StyledTableCell>
                            <StyledTableCell align="right">Total Earning</StyledTableCell>
                            <StyledTableCell align="right">Tax Amount</StyledTableCell>
                            <StyledTableCell align="right">Admin Profit</StyledTableCell>
                            <StyledTableCell align="right">Total Rental Count</StyledTableCell>
                            <StyledTableCell align="right">Total Season</StyledTableCell>
                            <StyledTableCell align="right">Total Episode</StyledTableCell>
                            <StyledTableCell align="right">TVOD Amount</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {report?.message?.map((row, index) => {
                            return (
                                <StyledTableRow key={index}>
                                    <StyledTableCell component="th" scope="row">{row.name}</StyledTableCell>
                                    <StyledTableCell align="right">{row.video_type}</StyledTableCell>
                                    <StyledTableCell align="right">{row.series_view}</StyledTableCell>
                                    <StyledTableCell align="right">{row.total_earning || '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.tax_amount || '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.admin_profit || '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.total_rental_count || '-'}</StyledTableCell>
                                    <StyledTableCell align="right">{row.total_season}</StyledTableCell>
                                    <StyledTableCell align="right">{row.total_episode}</StyledTableCell>
                                    <StyledTableCell align="right">{row.tvod_amount ?? '-'}</StyledTableCell>
                                </StyledTableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
